import { Outlet } from 'react-router';
import { CFT } from '@repo/runtime-kit/sentry/sentry-tags';
import { useSentrySetCft } from '@repo/shared-kit/sentry/use-sentry-set-cft';
import styles from './layout.module.css';

export function KycLayout() {
  useSentrySetCft({ cft: CFT.IDENTITY_VERIFICATION });

  return (
    <div className={styles.layout}>
      <Outlet />
    </div>
  );
}
